export function getCookieValue(name: string) {
  const cookieEntry = document.cookie
    .split('; ')
    .find((row) => row.startsWith(name));

  if (!cookieEntry) {
    return undefined;
  }

  const [, ...cookieValues] = cookieEntry.split('=');
  return cookieValues.join('=');
}

export function getCookieSearchParams() {
  const cookieSearchparams = new URLSearchParams();
  if (document.cookie.includes('tarteaucitron')) {
    cookieSearchparams.append(
      'consent',
      window.btoa(getCookieValue('tarteaucitron')),
    );
  }

  return cookieSearchparams;
}
